import { useEffect, useState } from "react";
import * as S from "./MatchContentsList.styles";
import { DataItemBox } from "../../atoms/DataItemBox";
import { Sheet } from "react-modal-sheet";
import BottomSheetContent from "../BottomSheet/BottomSheetContent";
import BottomSheetHeader from "../BottomSheet/BottomSheetHeader";
import { CustomSheet } from "../BottomSheet/customSheet.styles";
import {
  OrderType,
  SearchType,
  Transportation,
} from "../../../interface/transportation";
import { ReactComponent as IconArrow } from "../../../styles/assets/svg/icon-arrow-detail.svg";
import { ReactComponent as IconRouteArrow } from "../../../styles/assets/svg/icon-route-arrow.svg";
import { ReactComponent as IconFilterFalse } from "../../../styles/assets/svg/icon-filter.svg";
import { ReactComponent as IconFilterTrue } from "../../../styles/assets/svg/icon-filter-primary.svg";
import { ReactComponent as IconSelect } from "../../../styles/assets/svg/icon-select-down.svg";
import { ReactComponent as IconClose } from "../../../styles/assets/svg/icon-x-symbol.svg";
import { formatPrice } from "../../../common/common.fn";
import dayjs from "dayjs";

interface MatchContentsProps {
  orderData: OrderType[];
  search: SearchType[];
  showFilter: boolean;
  setSearch: React.Dispatch<React.SetStateAction<SearchType[]>>;
  setShowFilter: React.Dispatch<React.SetStateAction<boolean>>;
  register: any;
  handleSubmit: any;
  onSearchHandler: (data: any) => void;
  onDetailPageMoveHandler: (data: OrderType) => void;

  orderType?: boolean;
  setOrderType?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const MatchContents = ({
  orderData,
  showFilter,
  search,
  setShowFilter,
  setSearch,
  register,
  handleSubmit,
  onSearchHandler,
  onDetailPageMoveHandler,
  orderType,
  setOrderType,
}: MatchContentsProps) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (search.length === 0 && showFilter) {
      setShowFilter(false);
    }
  }, [search]);

  useEffect(() => {
    if (!showFilter && !isOpen && search.length > 0) {
      setSearch([]);
    }
  }, [showFilter, isOpen]);

  return (
    <S.MatchListLayot onSubmit={handleSubmit(onSearchHandler)}>
      <S.SearchLayout>
        <S.FilterButton
          onClick={() => setIsOpen(true)}
          className={isOpen || showFilter ? "isOpen" : ""}
        >
          <S.FilterRouteBox>
            <p>필터</p>
            {isOpen || showFilter ? (
              <IconFilterTrue width={40} height={40} />
            ) : (
              <IconFilterFalse width={40} height={40} />
            )}
          </S.FilterRouteBox>
        </S.FilterButton>
        <S.Input {...register("searchText")} />
        <S.Button type="submit">검색</S.Button>
      </S.SearchLayout>
      <CustomSheet
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      >
        <Sheet.Container>
          <Sheet.Header>
            <BottomSheetHeader />
          </Sheet.Header>
          <Sheet.Content>
            <BottomSheetContent
              search={search}
              setSearch={setSearch}
              setShowFilter={setShowFilter}
              setIsOpen={setIsOpen}
              register={register}
              onSearchHandler={onSearchHandler}
            />
          </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop />
      </CustomSheet>

      <S.MiddleBox>
        <S.FilterLayout>
          {search.length !== 0 &&
            search.map((data, idx) => {
              return (
                <S.FilterDataBox
                  key={idx}
                  onClick={() => {
                    const newSearch =
                      search &&
                      search?.filter(
                        (item: SearchType, index: number) => index !== idx
                      );
                    setSearch(newSearch);
                    onSearchHandler(newSearch);
                  }}
                >
                  <p>
                    {data.point} {data.data}
                  </p>
                  <IconClose width={10} height={10} fill="#FFFFFF" />
                </S.FilterDataBox>
              );
            })}
        </S.FilterLayout>
        <S.DateFilter onClick={() => setOrderType?.(!orderType)}>
          {orderType ? (
            <>
              <div>배차일순</div>
              <IconSelect />
            </>
          ) : (
            <>
              <div>요금순</div>
              <IconSelect />
            </>
          )}
        </S.DateFilter>
      </S.MiddleBox>
      <S.DataCardBoxLayout>
        {orderData?.map((item: OrderType, idx: number) => {
          return (
            <S.MainContentsSection key={idx}>
              <S.MainContentsList>
                <S.MainContentsItem>
                  <S.DataItemBox>
                    <S.DetailRouteBox>
                      <S.DetailRoute
                        onClick={() => onDetailPageMoveHandler(item)}
                      >
                        <div>상세보기</div>
                        <IconArrow />
                      </S.DetailRoute>
                    </S.DetailRouteBox>

                    <S.DataHeadBox>
                      <S.ContainerBookingBox>
                        <S.ContainerNo>
                          <span>컨테이너 No</span>
                          <span>
                            {item.container_no ? item.container_no : "-"}
                          </span>
                        </S.ContainerNo>
                        <S.BookingNo>
                          <span>Booking No</span>
                          <span>{item.bk_no ? item.bk_no : "-"}</span>
                        </S.BookingNo>
                      </S.ContainerBookingBox>
                    </S.DataHeadBox>

                    <S.DataRouteBox>
                      <DataItemBox
                        fontWeight="bold"
                        fontSize="1.4rem"
                        label="상차지"
                        content={item?.load_place_name}
                        route={true}
                      />
                      <IconRouteArrow />
                      <DataItemBox
                        fontWeight="bold"
                        fontSize="1.4rem"
                        label="작업지"
                        content={item?.work_place_name}
                        route={true}
                      />
                      <IconRouteArrow />
                      <DataItemBox
                        fontWeight="bold"
                        fontSize="1.4rem"
                        label="하차지"
                        content={item?.unload_place_name}
                        route={true}
                      />
                    </S.DataRouteBox>

                    <S.DataListBox>
                      <DataItemBox
                        label="요청사"
                        content={item?.company_name}
                      />
                      <DataItemBox
                        label="배차일자"
                        dateFontSize="1.6rem"
                        content={dayjs(item?.dispatch_request_date).format(
                          "YYYY-MM-DD"
                        )}
                      />
                      <DataItemBox
                        label="예상요금"
                        content={
                          formatPrice(item?.final_settlement_amount) + "원"
                        }
                      />
                    </S.DataListBox>

                    <S.ShippingNumberDivider />
                    <S.ShippingNumberBox>
                      <span>운송번호</span>
                      <span>{item?.order_number}</span>
                    </S.ShippingNumberBox>
                  </S.DataItemBox>
                </S.MainContentsItem>
              </S.MainContentsList>
            </S.MainContentsSection>
          );
        })}
      </S.DataCardBoxLayout>
    </S.MatchListLayot>
  );
};
